import Alpine from 'alpinejs';
import Intersect from '@alpinejs/intersect';

export function initAlpine() {
    Alpine.plugin(Intersect);
    window.Alpine = Alpine;
    Alpine.start();
}
